module.exports = __webpack_public_path__ + "static/media/wrongMove.c446634b.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wrongMove.m4a
// module id = 206
// module chunks = 0